import { Component } from '@angular/core';
import * as R from 'ramda';
import { environment } from 'environments/environment';
declare const DeviceBreadcrumb: any;

@Component({
    selector: 'app-jumbotron',
    templateUrl: './jumbotron.component.html',
    styleUrls: ['jumbotron.component.scss']
})
export class JumbotronComponent {

    jumbotronImg: string
    steps: string[]
    title: string
    subtitle: string
    SCRIPT_PATH = 'assets/js/device-breadcrumb.js';
    breadcrumbs: Breadcrumb[]
    private timeoWait = 150;

    constructor() { }

    busquedaTramiteStep() {
        this.steps = ['Sistema Nacional de Turnos'];
        this.title = 'Sistema Nacional de Turnos';
        this.subtitle = 'Buscá y pedí turnos para servicios del Estado Argentino';
        this.breadcrumbs = [];
    }

    turnoStep(nombreTramite: string, abreviaturaOrganismo: string) {
        this.steps = ['Sistema Nacional de Turnos', nombreTramite];
        this.title = nombreTramite;
        this.subtitle = abreviaturaOrganismo;
        this.breadcrumbs = [];
        this.loadScript();
    }

    isFinalStep(step: string) {
        return R.equals(R.last(this.steps), step);
    }

    busquedaTurnoStep() {
        this.breadcrumbs = [{url: environment.argentinagobar + 'jefatura', label: 'Jefatura de Gabinete de Ministros /'},
                            {url: environment.argentinagobar + 'jefatura/innovacion-ciencia-y-tecnologia', label: 'Innovación, Ciencia y Tecnología'},
                            {url: environment.argentinagobar + 'jefatura/innovacion-ciencia-y-tecnologia/tecnologias-de-la-informacion-y-las-comunicaciones',
                            label: 'Tecnologías de la Información y las Comunicaciones'},
                            {url: undefined, label: 'Turnos'}
        ];
        this.steps = [];
        this.title = 'Turnos';
        this.subtitle = 'Si tenés que hacer un trámite, podés sacar turno en línea y ganar tiempo.';
        this.loadScript();
    }

    isFinalBreadcrumbs(breadcrumb: Breadcrumb) {
      return R.equals(R.last(this.breadcrumbs), breadcrumb);
    }

    loadScript() {
      let testDeviceBreadcrumb;
      try{
        testDeviceBreadcrumb = new DeviceBreadcrumb();
      } catch (e) {
        const script = document.createElement('script');
        script.src = this.SCRIPT_PATH;
        script.async = true;
        document.body.appendChild(script);
      } finally {
        // Simulación del evento DOMContentLoaded para la lib device-breadcrumb.js
        setTimeout(function() {
          const event = new Event('DOMContentLoaded');
          document.dispatchEvent(event);
        }, this.timeoWait);
      }
    }
}




// WEBPACK FOOTER //
// /opt/snt/front-end-turnos/src/app/turnos/shared/jumbotron/jumbotron.component.ts